// Admin-only Dealer + Address columns placed before Store ID on Dealer Sales reports
const addr = (r) => r.full_address
  || [r.address, [r.city, [r.state, r.zip_code].filter(Boolean).join(" ")].filter(Boolean).join(", ")].filter(Boolean).join(", ");

export const StoreInfoHead = ({ className = "py-2 px-3 font-medium text-left" }) => (
  <><th className={className}>Dealer</th><th className={className}>Address</th></>
);

export const StoreInfoCells = ({ r, className = "py-2 px-3" }) => (
  <>
    <td className={`${className} vz-wide font-medium text-navy whitespace-nowrap`} title={r.dealer_name || r.sub_agent_name || ""} data-testid={`store-dealer-${r.door_tsp}`}>{r.dealer_name || r.sub_agent_name || "—"}</td>
    <td className={`${className} vz-wide text-slate-600 whitespace-nowrap`} title={addr(r) || ""} data-testid={`store-address-${r.door_tsp}`}>{addr(r) || "—"}</td>
  </>
);
